import { render, staticRenderFns } from "./RiskManagement.vue?vue&type=template&id=2b8d2d9e&scoped=true&"
import script from "./RiskManagement.vue?vue&type=script&lang=js&"
export * from "./RiskManagement.vue?vue&type=script&lang=js&"
import style0 from "./RiskManagement.vue?vue&type=style&index=0&id=2b8d2d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d2d9e",
  null
  
)

export default component.exports